import React from 'react';
import SearchPage from './SearchPage';
import { SearchStateLocationProvider } from './hooks/useSearchStateLocation';
import { SearchStateFiltersProvider } from './hooks/useSearchStateFilters';
import { SearchStateHitsProvider } from './hooks/useSearchStateHits';
import { SearchStateIndexProvider } from './hooks/useSearchStateIndex';

const SearchPageContainer = () => {
	return (
		<SearchStateIndexProvider>
			<SearchStateLocationProvider>
				<SearchStateFiltersProvider>
					<SearchStateHitsProvider>
						<SearchPage />
					</SearchStateHitsProvider>
				</SearchStateFiltersProvider>
			</SearchStateLocationProvider>
		</SearchStateIndexProvider>
	);
};

export default SearchPageContainer;
